var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "clvr-screen-control-template-list-draggable",
      class: { dragging: _vm.isDragging },
    },
    [
      _c("kh-list", {
        attrs: { items: _vm.localItems, dense: "", "draggable-options": {} },
        on: {
          orderChange: _vm.onOrderChange,
          dragStart: _vm.dragStart,
          dragEnd: _vm.dragEnd,
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function ({ item }) {
              return [
                !item.dataTypeChildren?.length
                  ? _c(
                      "v-list-item",
                      [
                        _c(
                          "v-list-item-icon",
                          [_c("kh-icon", { attrs: { icon: "mdi-drag" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-item-content",
                          [
                            _c("v-list-item-title", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "screenControl:screenControl-" + item.name
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-item-action",
                          { staticClass: "pr-12" },
                          [
                            _c("kh-switch", {
                              attrs: {
                                dense: "",
                                "input-value": _vm.activateData[item.id],
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onSwitchChange($event, item)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      "v-list-group",
                      {
                        attrs: { value: _vm.activeGroup[item.id] },
                        on: {
                          input: function ($event) {
                            return _vm.onGroupChange(item, $event)
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function () {
                                return [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c("kh-icon", {
                                        attrs: { icon: "mdi-drag" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "screenControl:screenControl-" +
                                                item.name
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-action",
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          "input-value":
                                            _vm.activateData[item.id],
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                          change: function ($event) {
                                            return _vm.onSwitchChange(
                                              $event,
                                              item
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _vm._v(" "),
                        _vm._l(item.dataTypeChildren, function (child, i) {
                          return _c(
                            "v-list-item",
                            { key: i },
                            [
                              _c(
                                "v-list-item-content",
                                { staticClass: "pl-14" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "screenControl:screenControl-" +
                                            child.name
                                        )
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-action",
                                { staticClass: "pr-12" },
                                [
                                  _c("v-switch", {
                                    attrs: {
                                      dense: "",
                                      "input-value": _vm.activateData[child.id],
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onSwitchChange($event, child)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }